import { BaseAjaxForm } from "mixs/base/form_ajax_mixin";
import { validations }  from "apps/actions/validations";
import { save }    from "apps/actions/common";
import { api }       from "apps/api";
import serializeJSON    from 'utilities/serialize_json';
import Timelag          from 'utilities/timelag'
import { Global }       from 'mixs/orders/planner/model';


class FormUpdate extends BaseAjaxForm {
  validFunction = validations.task;
  submitFunction = save;
  init(){
    super.init()
    let onSelectedLocation = (newVal: any, oldVal: any, objectPath: string) => { this.onSelectedLocation(newVal, oldVal, objectPath); }
    this.watchData(this.fullScope() + '.inputs.taskable.location_id.value', onSelectedLocation);
  }
  onSelectedLocation(location_id: any, oldVal: any, objectPath: string){
    if(location_id == '' || location_id == null){
      this.dispatch(
        {
          inputs: {
            taskable: {
              location_id:         { text: '', value: '' },
              locations_person_id: { text: '', value: '' }
            }
          }
        }
      );
    }else{
      setTimeout(() => {
        let newPath = '/locations/' + location_id + '/people/typeahead';
        let newValue = {inputs:{taskable: {locations_person_id: { typeahead: {get_action: newPath} }}}}
        let locationData = Global.getLocationData(location_id)
        if(locationData && locationData.who){
          newValue['inputs']['taskable']['who']= {value: locationData.who};
        }
        this.dispatch(newValue);
        this.getPerson(location_id);
      }, 10)
    }
  }
  getPerson(location_id){
    let payload = {
      url: '/locations/' + location_id + '/people/first'
    }
    api.get(payload)
      .then((data) => {this.onGetItem(data)})
      .catch((error) => {console.log(error);});
  }
  onGetItem(data){
    this.dispatch({inputs:{taskable: {locations_person_id: { text: data.data.name, value: data.data.value }}}});
  }
}
riot.mixin('forms.tasks.update', FormUpdate as riot.TagMixin)
